import { createFileRoute, notFound } from '@tanstack/react-router';

import { seoArtifactToHead } from '@/config/seo-head';
import { WritingDetailPage } from '@/features/writing/components/writing-detail-page';
import { loadWritingArticle } from '@/features/writing/writing-loaders';

export const Route = createFileRoute('/blog/$slug')({
  loader: async ({ params }) => {
    const result = await loadWritingArticle({ data: params.slug });
    if (!result) {
      throw notFound();
    }
    return result;
  },
  head: ({ loaderData }) => {
    if (!loaderData?.article.seo) {
      return {};
    }
    return seoArtifactToHead(loaderData.article.seo);
  },
  component: WritingDetailRoute,
});

function WritingDetailRoute() {
  const { article, bodyHtml, related } = Route.useLoaderData();
  return (
    <WritingDetailPage
      article={article}
      bodyHtml={bodyHtml}
      related={related}
    />
  );
}
